import React, { useState, useEffect } from "react";
import Helper from 'src/helper/Helper';
import { useObjCommonFilterStore } from "../../../hooks/objCommonFilter";
import Constants from "../../../helper/Constants";
import System from "../../../helper/system";
import { useQuoteStore } from "../../../hooks/quote";

const QuoteDetailFilterPopup = (props) => {
  const { SetStatus } = props
  const [formData, setFormData] = useState({ manufacturer: '', manufacturerPartNumber: '', customerPartNumber: '' })
  const [{ filter_list }, { }, { set_filter_list }] = useObjCommonFilterStore();
  const [validationDetail, setValidationDetail] = useState({});
  const charMsg = "Please enter at least 3 characters to execute a keyword search.";
  const { siteUser } = Constants;
  const [, , { clear_all_line_items }] = useQuoteStore();

  const searchList = [
    { searchKey: "manufacturerPartNumber", searchType: "Manufacturer Part Number", searchKeyword: "" },
    { searchKey: "customerPartNumber", searchType: "Customer Part Number", searchKeyword: "" },
    { searchKey: "manufacturer", searchType: "Manufacturer", searchKeyword: "" }
  ]

  useEffect(() => {
    const data = {}
    if (Object.keys(filter_list)?.length > 0) {
      Object.keys(filter_list).forEach((property) => {
        data[property] = filter_list[property].searchKeyword;
      });
    }
    setFormData(data);
  }, [filter_list]);

  const onHide = () => {
    SetStatus(false)
  };

  const onValueChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
    validateOnChange(field, value);
  }
  const validateOnChange = (field, value) => {
    if (field === 'customerPartNumber' || field === 'manufacturer' || field === 'manufacturerPartNumber') {
      if (value) {
        const isValid = Helper.validateMinCharacter(value);
        if (isValid) {
          const validateData = { ...validationDetail };
          delete validateData[field];
          setValidationDetail(validateData)
        }
      } else {
        const validateData = { ...validationDetail };
        delete validateData[field];
        setValidationDetail(validateData)
      }
    }
  }
  const onApplyFilter = () => {
    const data = formData;
    const isValid = checkValidation(data);
    const dataArr = Object.entries(formData).filter(([key, value]) => {
      return !!value
    })
    if (dataArr.length === 0) {
      clear_all_line_items()
      onHide();
      return;
    }
    if (isValid) {
      const orderSearch = [];
      Object.keys(formData).forEach((property) => {

        if (formData[property]) {
          const searchObj = searchList.find(f => f.searchKey === property)
          if (searchObj) {
            searchObj.searchKeyword = formData[property].trim();
            orderSearch.push(searchObj);
          }
        }
      });
      const filter = {}
      orderSearch.forEach((order) => {
        filter[order.searchKey] = order;
      })
      set_filter_list(filter)
      onHide();
    }
  }

  const checkValidation = (data) => {
    const validateData = {};
    Object.keys(data).forEach((property) => {
      if (property === 'customerPartNumber' || property === 'manufacturer' || property === 'manufacturerPartNumber') {
        if (data[property]) {
          const isValid = Helper.validateMinCharacter(data[property]);
          if (isValid === false) {
            validateData[property] = charMsg;
          } else {
            delete validateData[property];
          }
        } else {
          delete validateData[property];
        }
      }
    });
    setValidationDetail(validateData)
    return Object.keys(validateData).length <= 0;
  }

  return (
    <>
      <div className=" avnet-modal modal-800">

        <div className="avnet-modal-inner">
          <button type="button" className="close py-3" data-dismiss="modal"
            onClick={() => {
              onHide()
            }}>×
          </button>
          <div className="modal-header">
            <h4 className="modal-title text-center">Filter Quotes</h4>
          </div>
          <div className="modal-body">
            <div className="row bs5">
              <div className="form-group col-6">
                <label htmlFor="usr">Manufacturer</label>
                <input type="text" className="form-control" id="manufacturer" placeholder="Manufacturer"
                  value={formData.manufacturer}
                  onChange={({ target: { value } }) => onValueChange('manufacturer', value)}
                />
                {validationDetail.manufacturer &&
                  <span className="required-alert">{validationDetail.manufacturer}</span>}
              </div>
              <div className="form-group col-6">
                <label htmlFor="usr">Manufacturer Part Number</label>
                <input type="text" className="form-control" id="manufacturerPartNumber"
                  placeholder="Manufacturer Part Number"
                  value={formData.manufacturerPartNumber}
                  onChange={({ target: { value } }) => onValueChange('manufacturerPartNumber', value)}
                />
                {validationDetail.manufacturerPartNumber &&
                  <span className="required-alert">{validationDetail.manufacturerPartNumber}</span>}
              </div>
            </div>
            {System.avUserInfoData.currentUser === siteUser.CORE && <div className="row bs5">
              <div className="form-group col-6">
                <label htmlFor="usr">Customer Part Number</label>
                <input type="text" className="form-control" id="customerPartNumber"
                  placeholder="Customer Part Number"
                  value={formData.customerPartNumber}
                  onChange={({ target: { value } }) => onValueChange('customerPartNumber', value)} />
                {validationDetail.customerPartNumber &&
                  <span className="required-alert">{validationDetail.customerPartNumber}</span>}
              </div>
            </div>}
          </div>
          <div className="modal-footer text-center">
            <button type="button" className="bs5 btn btn-secondary" data-dismiss="modal"
              onClick={() => {
                onHide()
              }}>Close
            </button>
            <button type="button" className="bs5 btn btn-primary"
              onClick={() => {
                onApplyFilter()
              }}>Apply filters
            </button>
          </div>
        </div>

      </div>
    </>
  )
}

export default QuoteDetailFilterPopup;